import { useEffect, useState } from "react"

export const useCachedFilters = (key: string) => {
  const path = `filters-${key}`;
  const [value, setValue] = useState(null);

  const saveFilters = (filters) => {
    localStorage.setItem(path, JSON.stringify(filters));
  }

  useEffect(() => {
    const item = localStorage.getItem(path);
    setValue(item ? JSON.parse(item) : null);
  }, []);

  return {
    value,
    saveFilters
  }
}